<template>
  <div
    class="d-flex flex-column align-center justify-center"
    style="height: 100vh"
  >
    <v-progress-circular
      indeterminate
      color="primary"
      size="40"
    ></v-progress-circular>
    <div class="mt-4">Verification completed. Importing the report...</div>
  </div>
</template>

<script>
export default {
  mounted() {
    // The page is opened inside the verification iframe, notify the opener so
    // it can close the dialog and re-run the import once.
    if (window.parent && window.parent !== window) {
      window.parent.postMessage(
        { type: "enfortra-kba-completed" },
        window.location.origin
      );
    }
  },
};
</script>

<style></style>
